export default __webpack_public_path__ + "static/media/Lupus in fabula.8885829d.jpg";